import React, { Component } from 'react';
import Form from '../../../lib/ui/form';
import { Row, Button, Spin, message, notification } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { showErrorInNotification } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';

const hierarchy_assigner_fields = [
  {
    name: "MAKER",
    index: 'maker',
    type: 'select',
    filterable:true,
    options: []
  },
  {
    name: "CHECKER",
    index: 'checker',
    type: 'select',
    filterable:true,
    options: []
  },

  {
    name: "APPROVAL",
    index: 'approval',
    type: 'select',
    filterable:true,
    options: []
  },
  {
    name: "MANUAL",
    index: 'manual',
    type: 'select',
    filterable:true,
    options: []
  },
  {
    name: "REPORT DOWNLOAD",
    index: 'report_download',
    type: 'select',
    filterable:true,
    options: []
  },
  {
    name: "REPORT VIEW",
    index: 'report_view',
    type: 'select',
    filterable:true,
    options: []
  },
  {
    name:"Reject Reconciled",
    index:'reject_reconciled',
    type:'select',
    filterable:true,
    options: []
  }
]
class HierarchyAssigner extends Component {
  constructor(props) {
    super(props)

    this.state = {
      schema: hierarchy_assigner_fields,
      form_data: {}
    }

    this.get_setting = RESTExecutor.detail().config({
      label: 'hierarchy_assigner'
    }).callbacks((success) => {
      console.log("success", success);
      let _data = JSON.parse(JSON.stringify(success.result));
      let edit_data = _data;

      // Object.keys(_data).map((key) => {
      //   let item = _data[key];
      //   edit_data[key] = item.user_hierarchy
      // });

      this.setState({ form_data: edit_data });
    }, (error) => {
      console.log("error", error);
      showErrorInNotification(error)
    }).connect(props.domains.appSetting);

    this.set_setting = RESTExecutor.post().config({
      label: 'hierarchy_assigner'
    }).callbacks((success) => {
      console.log("success", success);
      // message.success(success.result.message||"Settings updated")
      notification.success({
        message:success.result.message||"Settings updated"
      })
    }, (error) => {
      console.log("error", error);
      showErrorInNotification(error);
    }).connect(props.domains.appSetting);

    this.list_hierarchy = RESTExecutor.list().config({
      label: 'user_hierarchy'
    }).callbacks((success) => {
      this.get_setting.execute();
      let rows = (success.result && success.result.rows) || [];
      let options = [];
      rows.map((item) => {
        options.push({
          text: item.name,
          value: item.hierarchy
        })
      });
      let _schema = this.state.schema;
      _schema.map((item) => {
        item.options = options
      });
      console.log("new schema",_schema)
      this.setState({ schema: _schema });
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.users)

    this.list_hierarchy.execute()

  }

  updateSetting = () => {
    let data = JSON.parse(JSON.stringify(this.state.form_data));
    let sending_data = data;
    // Object.keys(data).map((key) => {
    //   let value = data[key];
    //   sending_data[key] = {
    //     "user_hierarchy": value
    //   }
    // });
    console.log("sending data", sending_data)

    this.set_setting.execute(sending_data)


  }

  render() {
    const { schema } = this.state;
    let set_setting_resp = this.set_setting.response();
    let get_setting_resp=this.get_setting.response();
    if(get_setting_resp.fetching){
        return <center><Spin/></center>
    }

    return (
      <div>
          <ErrorWrapper
          error={get_setting_resp}
          onReload={()=>{
              this.get_setting.execute();
          }}
          >
        <Form
          hideTitle
          forCreate={true}
          initialData={this.state.form_data || {}}
          submitted={this.state.submitted}
          onChange={(data) => {
            this.setState({ form_data: data ,submitted:false})
          }}
          fields={schema}
          submitting={{}}
          errorMessage={set_setting_resp.error_message}
          validationErrors={set_setting_resp.validation_errors}
        />
        <br></br>
        <Row type='flex' justify='end'>
          <Button type='primary'
            disabled={set_setting_resp.fetching}
            loading={set_setting_resp.fetching}
            onClick={() => {
              this.setState({submitted:true})
              this.updateSetting()
            }}
          >Submit</Button>
        </Row>
        </ErrorWrapper>
      </div>
    );
  }
}

export default withDomains(HierarchyAssigner,"settings" ,"appSetting","users");
